import { render, staticRenderFns } from "./ResolveButton.vue?vue&type=template&id=87a91e20"
import script from "./ResolveButton.vue?vue&type=script&lang=js"
export * from "./ResolveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports